<template>
  <!-- 入院参观登记表 -->
  <div>
    <el-row class="bg">
      <el-row>
        <el-col :span="8">
          <el-button type="warning" icon="el-icon-arrow-left" @click="back">返回</el-button>
        </el-col>
        <el-col :span="8">
          <h2 style="text-align:center">入院参观信息填写</h2>
        </el-col>
        <el-col :span="8">
        </el-col>
      </el-row>
      <el-form :inline="true" :model="addForm" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-form-item label="老人姓名" prop="oldName" label-width="150px">
            <el-input v-model="addForm.oldName" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="性别" label-width="100px">
            <el-select v-model="addForm.oldSex" style="width: 180px">
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期" label-width="150px">
            <el-input v-model="addForm.birthday" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="年龄" label-width="100px">
            <el-input v-model="addForm.age" placeholder="年龄" style="width: 180px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="身份证号">
            <el-input v-model="addForm.idcard" style="width: 490px;"></el-input>
          </el-form-item>
          <el-form-item label="预约时间">
            <el-date-picker :clearable="true" v-model="addForm.visitTime" type="date" placeholder="请选择参观时间"
              value-format="yyyy-MM-dd" style="width: 180px;" format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="评估员" label-width="100px">
            <el-input v-model="addForm.evaluator" style="width: 180px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="老人体温">
            <el-input v-model="addForm.temperature" style="width: 490px;"></el-input>
          </el-form-item>
          <el-form-item label="抗原结果">
            <el-input v-model="addForm.alloantigen" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="消杀" label-width="100px">
            <el-input v-model="addForm.disinfect" style="width: 180px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="家庭地址">
            <el-input v-model="addForm.address" style="width: 490px;"></el-input>
          </el-form-item>
          <el-form-item label="退休工资">
            <el-input v-model="addForm.pension" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="接待员" label-width="100px">
            <el-input v-model="addForm.receptionist" style="width: 180px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="监护人姓名" prop="oldName" label-width="150px">
            <el-input v-model="addForm.guardian" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="性别" label-width="100px">
            <el-select v-model="addForm.guardianSex" style="width: 180px">
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系电话" label-width="150px">
            <el-input v-model="addForm.guardianPhone" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="年龄" label-width="100px">
            <el-input v-model="addForm.guardianAge" placeholder="年龄" style="width: 180px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="身份证号码" prop="oldName" label-width="150px">
            <el-input v-model="addForm.guardianIdcard" style="width: 490px;"></el-input>
          </el-form-item>
          <el-form-item label="与老人的关系" label-width="150px">
            <el-input v-model="addForm.guardianRelationship" style="width: 180px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="家庭住址" label-width="150px">
            <el-input v-model="addForm.guardianAddress" style="width: 1120px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="家属姓名" prop="oldName" label-width="150px">
            <el-input v-model="addForm.family" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="性别" label-width="100px">
            <el-select v-model="addForm.familySex" style="width: 180px">
              <el-option label="男" value="0"></el-option>
              <el-option label="女" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系电话" label-width="150px">
            <el-input v-model="addForm.familyPhone" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="年龄" label-width="100px">
            <el-input v-model="addForm.familyAge" placeholder="年龄" style="width: 180px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="身份证号码" label-width="150px">
            <el-input v-model="addForm.familyIdcard" style="width: 490px;"></el-input>
          </el-form-item>
          <el-form-item label="与老人的关系" label-width="150px">
            <el-input v-model="addForm.familyRelationship" style="width: 180px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="家庭住址" label-width="150px">
            <el-input v-model="addForm.familyAddress" style="width: 1120px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="初评老人情况" label-width="150px">
            <el-input v-model="addForm.evaluationCondition" type="textarea" :rows="3" resize="none"
              style="width: 1120px;"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item prop="room" label="是否精神病史" label-width="200px">
              <el-radio-group v-model="addForm.judgelist[0]" class="radiogroup">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="room" label="是否传染病史" label-width="200px">
              <el-radio-group v-model="addForm.judgelist[1]" class="radiogroup">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="room" label="是否癌症" label-width="200px">
              <el-radio-group v-model="addForm.judgelist[2]" class="radiogroup">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="room" label="是否认知症障碍患者" label-width="200px">
              <el-radio-group v-model="addForm.judgelist[3]" class="radiogroup">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="room" label="是否本市区户籍" label-width="200px">
              <el-radio-group v-model="addForm.judgelist[4]" class="radiogroup">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="room" label="是否法定监护人及直系亲属" label-width="200px">
              <el-radio-group v-model="addForm.judgelist[5]" class="radiogroup">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="room" label="是否有服务费缴费能力" label-width="200px">
              <el-radio-group v-model="addForm.judgelist[6]" class="radiogroup">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item prop="room" label="是否非急性疾病患病期及刚因大病手术出院一月内" label-width="330px">
              <el-radio-group v-model="addForm.judgelist[7]" class="radiogroup">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item prop="room" label="入院对象是否主观意愿同意进入养老院" label-width="250px">
              <el-radio-group v-model="addForm.judgelist[8]" class="radiogroup">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="room" label="其他不符入院情况" label-width="200px">
              <el-input v-model="addForm.otherCondition" style="width: 1070px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="room" label="接待评价满意度" label-width="200px">
              <el-radio-group v-model="addForm.satisfaction" class="radiogroup">
                <el-radio label="3">非常满意</el-radio>
                <el-radio label="2">基本满意</el-radio>
                <el-radio label="1">不满意</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="备注" label-width="200px">
              <el-input v-model="addForm.remark" type="textarea" :rows="4" resize="none"
                style="width: 1070px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="text-align: center">
          <el-button type="primary" @click="submitAdd">提 交</el-button>
        </el-row>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "OldVisitAdd",
  data() {
    return {
      addForm: {
        oldName: "",
        oldSex: "",
        birthday: "",
        age: "",
        idcard: "",
        visitTime: "",
        evaluator: "",
        temperature: "",
        alloantigen: "",
        disinfect: "",
        address: "",
        pension: "",
        receptionist: "",
        guardian: "",
        guardianSex: "",
        guardianAge: "",
        guardianPhone: "",
        guardianAddress: "",
        guardianIdcard: "",
        guardianRelationship: "",
        family: "",
        familySex: "",
        familyAge: "",
        familyPhone: "",
        familyAddress: "",
        familyIdcard: "",
        familyRelationship: "",
        evaluationCondition: "",
        judge: "",
        otherCondition: "",
        remark: "",
        satisfaction: 0,
        judgelist: [0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
    };
  },
  methods: {
    submitAdd() {
      let param = this.addForm;
      param.judge = this.addForm.judgelist.join('-');
      this.$postJson(
        this.addForm.id
          ? "omc/oldVisit/update"
          : "omc/oldVisit/add",
        param
      ).then(res => {
        if (res.code == 200) {
          this.$message({ message: res.message, type: "success" });
          bus.$emit('close_current_tags');
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      })
    },
    back() {
      bus.$emit('close_current_tags');
    }
  },
  mounted() {
    if(this.$route.query){
      this.$route.query.judgelist = this.$route.query.judge.split("-");
      this.$route.query.judgelist.forEach(item=>{
        item = Number(item);
      })
      this.addForm = this.$route.query;
      console.log(this.addForm)
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.bg {
  background: #fff;
  padding: 5px;
}

.demo-form-inline {
  margin-top: 10px;
}
</style>